// extracted by css-extract-rspack-plugin
export default {"close":"FKvm74"};